import React, { useContext } from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import CdnImage from './CdnImage';
import PropTypes from 'prop-types';
import LayoutContext from '../../contexts/Layout';

export const Avatar = ({ imageUri, size = 80, style }) => {
    const { layout } = useContext(LayoutContext);

    if (layout.device.isNative) {
        return (
            <View style={StyleSheet.flatten(Styles.mobileContainer, { marginHorizontal: layout.styleGuide.spacer7 }, style)}>
                <CdnImage height={size} width={size} uri={imageUri} style={Styles.image(size)} />
            </View>
        );
    }

    return (
        <View
            style={StyleSheet.flatten(Styles.container, { marginRight: layout.styleGuide.spacer7 }, style)}
            dataSet={{ spacerRight: `StyleGuide.Spacer7(${layout.styleGuide.spacer7})` }}
        >
            <CdnImage height={size} width={size} uri={imageUri} style={Styles.image(size)} />
        </View>
    );
};

const Styles = StyleSheet.create({
    container: {
        justifyContent: 'center'
    },
    mobileContainer: {
        justifyContent: 'center',
        height: 80,
        width: 80,
        marginHorizontal: 10,
        borderColor: 'transparent'
    },
    image: size => {
        return {
            borderRadius: Platform.OS.equals('web') ? '50%' : 40,
            height: size,
            width: size,
            overflow: 'hidden'
        };
    }
});

Avatar.propTypes = {
    imageUri: PropTypes.string.isRequired,
    size: PropTypes.number,
    style: PropTypes.object
};
